export interface IXenaAppTranslation {
  name?: string;
  description?: string;
  details?: string;
  termsMarkdown?: string;
}
